import script from "./DegradoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DegradoForm.vue?vue&type=script&setup=true&lang=js"

import "./DegradoForm.vue?vue&type=style&index=0&id=522b0536&lang=css"

const __exports__ = script;

export default __exports__